import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

/** Official Google Pay acceptance mark (`google-pay-mark_800.svg`), including required clear space. */
const OFFICIAL_MARK_WIDTH = 1094;
const OFFICIAL_MARK_HEIGHT = 742;
const OFFICIAL_PILL_WIDTH = 752;
const OFFICIAL_CLEAR_SPACE = (OFFICIAL_MARK_WIDTH - OFFICIAL_PILL_WIDTH) / 2;

export const GOOGLE_PAY_MARK_SIZE = 40;
export const GOOGLE_PAY_MARK_WIDTH = Math.round(
  (GOOGLE_PAY_MARK_SIZE * OFFICIAL_MARK_WIDTH) / OFFICIAL_MARK_HEIGHT
);
export const GOOGLE_PAY_MARK_OFFSET = -Math.round(
  (GOOGLE_PAY_MARK_SIZE * OFFICIAL_CLEAR_SPACE) / OFFICIAL_MARK_HEIGHT
);

export const IconPaymentTypeGooglePay = (props: IconProps) => {
  const { size = GOOGLE_PAY_MARK_SIZE, color: _color, ...otherProps } = props;
  const height = size;
  const width = Math.round((size * OFFICIAL_MARK_WIDTH) / OFFICIAL_MARK_HEIGHT);

  return (
    <Svg
      fill="none"
      viewBox={`0 0 ${OFFICIAL_MARK_WIDTH} ${OFFICIAL_MARK_HEIGHT}`}
      {...otherProps}
      width={width}
      height={height}
    >
      <Path
        d="M722.7 170h-352c-110 0-200 90-200 200s90 200 200 200h352c110 0 200-90 200-200s-90-200-200-200z"
        fill="#fff"
      />
      <Path
        d="M722.7 186.2c24.7 0 48.7 4.9 71.3 14.5 21.9 9.3 41.5 22.6 58.5 39.5 16.9 16.9 30.2 36.6 39.5 58.5 9.6 22.6 14.5 46.6 14.5 71.3s-4.9 48.7-14.5 71.3c-9.3 21.9-22.6 41.5-39.5 58.5-16.9 16.9-36.6 30.2-58.5 39.5-22.6 9.6-46.6 14.5-71.3 14.5h-352c-24.7 0-48.7-4.9-71.3-14.5-21.9-9.3-41.5-22.6-58.5-39.5-16.9-16.9-30.2-36.6-39.5-58.5-9.6-22.6-14.5-46.6-14.5-71.3s4.9-48.7 14.5-71.3c9.3-21.9 22.6-41.5 39.5-58.5 16.9-16.9 36.6-30.2 58.5-39.5 22.6-9.6 46.6-14.5 71.3-14.5zm0-16.2h-352c-110 0-200 90-200 200s90 200 200 200h352c110 0 200-90 200-200s-90-200-200-200z"
        fill="#3C4043"
      />
      <Path
        d="M529.3 384.2v60.5h-19.2V295.3H561c12.9 0 23.9 4.3 32.9 12.9 9.2 8.6 13.8 19.1 13.8 31.5 0 12.7-4.6 23.2-13.8 31.7-8.9 8.5-19.9 12.7-32.9 12.7h-31.7v.1zm0-70.5v52.1h32.1c7.6 0 14-2.6 19-7.7 5.1-5.1 7.7-11.3 7.7-18.3 0-6.9-2.6-13-7.7-18.1-5-5.3-11.3-7.9-19-7.9h-32.1v-.1z"
        fill="#3C4043"
      />
      <Path
        d="M657.9 339.1c14.2 0 25.4 3.8 33.6 11.4 8.2 7.6 12.3 18 12.3 31.2v63h-18.3v-14.2h-.8c-7.9 11.7-18.5 17.5-31.7 17.5-11.3 0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6 4-19 12-25.2 8-6.3 18.7-9.4 32-9.4 11.4 0 20.8 2.1 28.1 6.3v-4.4c0-6.7-2.6-12.3-7.9-17-5.3-4.7-11.5-7-18.6-7-10.7 0-19.2 4.5-25.4 13.6l-16.9-10.6c9.3-13.5 23.1-20.2 41.3-20.2zm-24.8 74.2c0 5 2.1 9.2 6.4 12.5 4.2 3.3 9.2 5 14.9 5 8.1 0 15.3-3 21.6-9s9.5-13 9.5-21.1c-6-4.7-14.3-7.1-25-7.1-7.8 0-14.3 1.9-19.5 5.6-5.3 3.8-7.9 8.5-7.9 14.1z"
        fill="#3C4043"
      />
      <Path
        d="M808.2 342.4 744.2 489.6h-19.8l23.8-51.5-42.2-95.7h20.9l30.4 73.4h.4l29.6-73.4h20.9z"
        fill="#3C4043"
      />
      <Path
        d="M452.93 372c0-6.26-.56-12.25-1.6-18.01h-80.48v33L417.2 387c-1.88 10.98-7.93 20.34-17.2 26.58v21.41h27.59C443.7 420.08 452.93 398.04 452.93 372z"
        fill="#4285F4"
      />
      <Path
        d="M400.01 413.58c-7.68 5.18-17.57 8.21-29.14 8.21-22.35 0-41.31-15.06-48.1-35.36h-28.46v22.08c14.1 27.98 43.08 47.18 76.56 47.18 23.14 0 42.58-7.61 56.73-20.71l-27.59-21.4z"
        fill="#34A853"
      />
      <Path
        d="M320.09 370.05c0-5.7.95-11.21 2.68-16.39v-22.08h-28.46c-5.83 11.57-9.11 24.63-9.11 38.47s3.29 26.9 9.11 38.47l28.46-22.08a51.684 51.684 0 0 1-2.68-16.39z"
        fill="#FABB05"
      />
      <Path
        d="M370.87 318.3c12.63 0 23.94 4.35 32.87 12.85l24.45-24.43c-14.85-13.83-34.21-22.32-57.32-22.32-33.47 0-62.46 19.2-76.56 47.18l28.46 22.08c6.79-20.3 25.75-35.36 48.1-35.36z"
        fill="#E94235"
      />
    </Svg>
  );
};
